import script from "./loginBox.vue?vue&type=script&setup=true&lang=js"
export * from "./loginBox.vue?vue&type=script&setup=true&lang=js"

import "./loginBox.vue?vue&type=style&index=0&id=003ce997&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003ce997"]])

export default __exports__